import React, { useState } from 'react';
import { Card, CardContent, CardFooter, CardHeader } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Check, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const CourseCard = ({ course, index = 0 }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
    >
      <Card
        className="h-full flex flex-col overflow-hidden border-2 transition-all duration-300 hover:shadow-xl hover:border-primary cursor-pointer group"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {/* Header with Icon */}
        <CardHeader className="bg-gradient-to-br from-primary/5 to-secondary/5 pb-8">
          <div className="flex items-start justify-between mb-4">
            <div className={`text-5xl transform transition-transform duration-300 ${isHovered ? 'scale-110' : ''}`}>
              {course.icon}
            </div>
            <Badge variant="secondary" className="text-xs font-semibold">
              {course.duration}
            </Badge>
          </div>
          <h3 className="text-2xl font-heading font-bold text-foreground mb-2">
            {course.name}
          </h3>
          <div className="space-y-1">
            <p className="text-sm text-muted-foreground font-medium">
              {course.class}
            </p>
            <Badge className="bg-secondary text-secondary-foreground text-xs">
              {course.target}
            </Badge>
          </div>
        </CardHeader>

        <CardContent className="flex-1 pt-6">
          <p className="text-muted-foreground mb-6 leading-relaxed">
            {course.description}
          </p>

          <div className="space-y-3">
            <p className="text-sm font-semibold text-foreground mb-3">Key Features:</p>
            {course.features.map((feature, idx) => (
              <div key={idx} className="flex items-start space-x-3">
                <div className="h-5 w-5 rounded-full bg-success/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <Check className="h-3 w-3 text-success" />
                </div>
                <span className="text-sm text-foreground">{feature}</span>
              </div>
            ))}
          </div>
        </CardContent>

        <CardFooter className="flex flex-row gap-3 space-y-3 mt-auto pt-6">
          <Link to="/enquiry" className="w-full">
            <Button className="w-full bg-primary hover:bg-primary-dark text-primary-foreground group">
              Enquire Now
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </Link>
          <Link to={`/courses/${course.id}`} className="w-full !mt-0">
            <Button variant="outline" className="w-full">
              View Details
            </Button>
          </Link>
        </CardFooter>
      </Card>
    </motion.div>
  );
};
